export enum RoutesEnum {
  Default = '/NotFound',
  Login = '/login',
  Start = '/',
  CallbackPage = '/callback',
  SilentRenewPage = '/silentrenew',
  Calendar = '/calendar',
  AbsenceReport = '/admin/absence/report',
  UnAnsweredAbsence = '/admin/absence/unanswered',
  ScheduleReport = '/admin/schedule',
  Career = '/career',
  Form = '/form',
  Employee = '/employee',
  Progress = '/progress',
  Profile = '/profile',
  LunchOrder = '/lunchOrder',
  Admin = '/admin',
  AdminLunch = '/admin/lunch',
  AdminForm = '/admin/form',
  AdminEditForm = '/admin/form/:formId/edit',
  AdminLocation = '/admin/location',
  AdminEditLocation = '/admin/location/:locationId/edit',
  Pages = '/pages',
  PageCategory = '/pages/:categoryGuid',
  PageDetail = '/pages/:categoryGuid/:pageGuid',
  PagesAdmin = '/pages/admin',
  PagesAdminCategories = '/pages/admin/categories',
  PagesAdminEdit = '/pages/admin/edit/:pageGuid?',
  PagesAdminConfirmations = '/pages/admin/:pageGuid/confirmations',
}
